import client from '../../base-api';

const serviceURL = '/socio-therapy-coaching-overview';

const overviewCaseManagementCoachingService = {
    getNewAndActiveList(filterData: any) {
        return client.get(`${serviceURL}/new-and-active`, {params: filterData});
    },
    getFinishedList(filterData: any) {
        return client.get(`${serviceURL}/finished`, {params: filterData});
    },
    getArchivedList(filterData: any) {
        return client.get(`${serviceURL}/archived`, {params: filterData});
    },

}
export default overviewCaseManagementCoachingService;